:host {
  display: inline-block;
}

:host(.no-toggle) {
  display: none;
}
